import { render, staticRenderFns } from "./RejectParticipation.vue?vue&type=template&id=64e0eb82&scoped=true&"
import script from "./RejectParticipation.vue?vue&type=script&lang=ts&"
export * from "./RejectParticipation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0eb82",
  null
  
)

export default component.exports